import {
  faChartBar,
  faPray,
  faQuestion,
  faRunning,
  faTrophy,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "provider/AuthProvider";
import React from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Button, MenuItem, SideMenu } from "stories";
import { ReactComponent as IFasteLogo } from "../../assets/app-icon-ios.svg";
import styles from "./LayoutWithSideMenu.module.scss";
import { getAuth, signOut } from "firebase/auth";

const panels = [
  {
    id: "quiz",
    label: "Quiz",
    icon: <FontAwesomeIcon icon={faQuestion} />,
  },
  {
    id: "poengliste",
    label: "Poengliste",
    icon: <FontAwesomeIcon icon={faTrophy} />,
  },
  {
    id: "aktiviteter",
    label: "Aktiviteter",
    icon: <FontAwesomeIcon icon={faRunning} />,
  },
  {
    id: "dua",
    label: "Dua",
    icon: <FontAwesomeIcon icon={faPray} />,
  },
  {
    id: "brukere",
    label: "Brukere",
    icon: <FontAwesomeIcon icon={faUser} />,
  },
  {
    id: "statistikk",
    label: "Statistikk",
    icon: <FontAwesomeIcon icon={faChartBar} />,
  },
];

const LayoutWithSideMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setOrgNumber, setUid, mosqueName } = useAuth();

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);

      sessionStorage.clear();

      setOrgNumber("");
      setUid("");

      navigate("/innlogging");
    } catch (error) {
      console.error("Failed to log out:", error);
      alert("Noe gikk galt under utloggingen. Prøv igjen senere.");
    }
  };

  return (
    <div className="App">
      <div className="sideMenu">
        <SideMenu>
          <div style={{ textAlign: "center" }}>
            <IFasteLogo
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            />
            <h4
              style={{
                color: "rgba(230, 233, 230, 0.444)",
                fontWeight: "bold",
              }}
            >
              {mosqueName}
            </h4>
          </div>

          <hr
            style={{
              border: "1px solid rgba(230, 233, 230, 0.444)",
              margin: "0 20px",
            }}
          />

          {panels.map((panel) => {
            const isActive = location.pathname === `/${panel.id}`;
            return (
              <Link
                to={`/${panel.id}`}
                key={panel.id}
                className={isActive ? styles.activeLink : ""}
              >
                <MenuItem label={panel.label} icon={panel.icon} />
              </Link>
            );
          })}

          <div style={{ marginTop: "auto", padding: "10px", width: "100%" }}>
            <Button
              onClick={handleLogout}
              variant="fullWidth"
              size="large"
              backgroundColor="#db5c54"
            >
              Logg ut
            </Button>
          </div>
        </SideMenu>
      </div>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default LayoutWithSideMenu;
